import React from 'react'
import PropTypes from 'prop-types'
import FullRateTableDefaultVersion from './default-version'
import FullRateTableFoxVersion from './fox-version'

const foxThemes = ['fox', 'fox1']

const FullRateTableApp = ({ theme, ...props }) => {
  if (foxThemes.includes(theme)) {
    return <FullRateTableFoxVersion {...props} theme={theme} />
  }

  return <FullRateTableDefaultVersion {...props} theme={theme} />
}

FullRateTableApp.propTypes = {
  theme: PropTypes.string,
}

export default FullRateTableApp
